/* eslint-disable import/no-unused-modules */
import nookies from "nookies"
import type { GetServerSidePropsContext } from "next"

import { jsonParse, jsonStringify } from "common/helpers/serialization"
import type { FeatureFlags, FeatureFlag } from "common/types/featureflags"

export const getFeatureFlags = (
  context: GetServerSidePropsContext,
): FeatureFlags | undefined => {
  const cookies = nookies.get(context)

  if (!cookies.features) return undefined

  const featureFlags: FeatureFlags = jsonParse(cookies.features)

  return featureFlags
}

export const isFeatureFlagOn = (
  featureFlag: FeatureFlag,
  features: FeatureFlags,
): boolean => {
  if (features[featureFlag]) return true

  return false
}

export const setFeatureFlag = (
  nextState: boolean,
  featureFlag: FeatureFlag,
  featureFlags: FeatureFlags,
): void => {
  if (!featureFlags) {
    const nextFeatureFlags: FeatureFlags = {
      [featureFlag]: nextState,
    }

    nookies.set(null, "features", jsonStringify(nextFeatureFlags))
  }

  const nextFeatureFlags: FeatureFlags = {
    ...featureFlags,
    [featureFlag]: nextState,
  }

  const THIRTY_DAYS = 30 * 24 * 60 * 60
  nookies.set(null, "features", jsonStringify(nextFeatureFlags), {
    maxAge: THIRTY_DAYS,
    path: "/",
  })
}
